import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { withRouter, useNavigate } from "react-router-dom";
// import LinesEllipsis from 'react-lines-ellipsis';

// import SwipeToRevealActions from '../SwipeToRevealActions'


import CategoryBalanceButton from './CategoryBalanceButton';
import BudgetProgress from './BudgetProgress';
import { toCurrency, toNumber, textEllipsis } from '../util/Util';


export default function DesktopBudgetCategory(props) {
	let navigate = useNavigate();
    return (
        <div id={"budgetCat-" + props.catid} className='budgetcatdiv'>
            

                <div className='container bcatContainer'>
                    <div id={"budgetCat" + props.catid + "row1"} className='row'>
                        <div className='col-4'>
                            <div className='catName' >
                                {props.name}
                        
                            </div>
                        </div>

                        <div className='col-2 text-end'>
                            <BudgetProgress
                                budget={props.budget}
                                spent={props.spent}
                                bal={props.bal}
                                name={props.name}
                                itemId={props.itemId} />
                        </div>

                        <div className='col-2'>
                            <input type="text"
                                id={"budget-input-" + props.itemId}
                                className="budgetAmt"
                                defaultValue={toCurrency(props.budgeted)}
                                aria-label="Amount (to the nearest dollar)"
                                disabled={props.is_disabled}
                                onBlur={e => {
                                    const newId = props.itemId;
                                    console.log(props.itemId);
                                    console.log(props.budget.filter(d => d.budgetid == props.itemId)[0]['budgeted']);
                                    const oldVal = props.budget.filter(d => d.budgetid == props.itemId)[0]['budgeted'];
                                    // console.log(oldVal);
                                    props.updateBudgetAmt(newId, e.target.value, oldVal, props.itemId);
                                }}
                            />
                        </div>
                        <div className='col-1 text-end'>
                            <span className='catSpent' >
                                {toCurrency(Math.abs(props.spent))}
                            </span>

                        </div>
                        <div className='col-2 text-end desktopBudgetBal'>
                            {props.bal >= 0 ? (
                                <>
                                    {props.bal == 0 ? (
                                        <div className="budgetBalDiv budgetBal-neu">{toCurrency(Math.abs(props.bal))}</div>
                                    ) : (
                                        <div className="budgetBalDiv budgetBal-pos">{toCurrency(Math.abs(props.bal))}</div>
                                    )}

                                </>
                            ) : (
                                <>
                                    <div className="budgetBalDiv budgetBal-neg">{toCurrency(Math.abs(props.bal))}</div>

                                </>
                            )}
                        </div>
                        <div className='col-1 text-end desktopBudgetArrow'>
                            <span className='catSpent' >
                            <FontAwesomeIcon icon={faAngleRight}
                                    className="ms-1"
                                    onClick={() => {
                                        console.log()
                                        navigate('/Category',
                                            {state: {
                                                // any values/objects/etc you want to also send to pushed route/path
                                                catid: props.catid,
                                                cats: props.budget
                                            }},
                                        )
                                    }} />
                            </span>

                        </div>
                    </div>
                    </div>
        </div >

    );
}
